import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';

const useStyles = makeStyles({
    root: {
        marginTop: 30,
    },
    inputStyle: {
        textAlign: 'center',
        fontSize: 15,
    },
});

export default function BottomNav(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    return (
        <BottomNavigation
            value={value}
            onChange={(event, newValue) => {
                setValue(newValue);
            }}
            className={classes.root}
        >
            <BottomNavigationAction onClick={props.handleBack} label="Prev" showLabel icon={<ArrowBack />} />
            <BottomNavigationAction onClick={props.handleNext} label="Next" showLabel icon={<ArrowForward />} />
        </BottomNavigation>
    );
}
